import { createSlice } from "@reduxjs/toolkit"
import HbsRaportipsablonDTO from "src/models/Raporlama/HbsRaportipsablonDTO";
import VwHastaraporDTO from "src/models/Raporlama/VwHastaraporDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads"

interface IHastaraporState {
    activeRow: VwHastaraporDTO,
    iptalOlaniGosterme: boolean,
    aktifMuracaat: boolean,
    islemSecimOpen: boolean,
    edit: boolean,
    sablonSecimOpen: boolean,
    sablonActiveRow: HbsRaportipsablonDTO,
    sonucHazirListele: boolean,
}

const HastaRaporlamaSlice = createSlice<IHastaraporState, MapReducerPayloads<IHastaraporState, {
    setState: IHastaraporState,
    setEdit: boolean
}>>({
    name: "HastaRaporlama",
    initialState: {
        activeRow: new VwHastaraporDTO(),
        iptalOlaniGosterme: true,
        aktifMuracaat: true,
        islemSecimOpen: false,
        edit: false,
        sablonSecimOpen: false,
        sablonActiveRow: new HbsRaportipsablonDTO(),
        sonucHazirListele: true,
    },
    reducers: {
        setState: (state, action) => action.payload,
        setEdit: (state, action) => {
            state.edit = action.payload
        },
    }
})

export default HastaRaporlamaSlice